/* eslint-disable react/prop-types */ // TODO: add props
import cx from 'classnames';
import style from './RadioIcon.scss';

const SelectedSVG = ({ className }) => (
  <svg
    className={className}
    data-test="selected"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="9" stroke="#448ABF" strokeWidth="2" />
    <circle cx="10" cy="10" r="5" fill="#448ABF" />
  </svg>
);

const UnselectedHoverSVG = ({ className }) => (
  <svg
    className={className}
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="14" cy="14" r="9" stroke="#929394" strokeWidth="2" />
    <circle
      cx="14"
      cy="14"
      r="12"
      stroke="#929394"
      strokeOpacity="0.2"
      strokeWidth="4"
    />
  </svg>
);

const UnselectedSVG = ({ className }) => (
  <svg
    className={className}
    data-test="unselected"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="9" stroke="#929394" strokeWidth="2" />
  </svg>
);

const RadioIcon = ({ selected, hover }) => {
  if (selected) {
    return <SelectedSVG className={style.radioSVG} />;
  }

  if (hover) {
    return <UnselectedHoverSVG className={cx(style.radioSVG, style.hover)} />;
  }

  return <UnselectedSVG className={cx(style.radioSVG)} />;
};

export default RadioIcon;
